import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projectActivityList.duplicate';

export default defineMessages({
  duplicateWarningTitle: {
    id: `${scope}.duplicateWarningTitle`,
    defaultMessage: 'Duplicate {elementType} {elementTitle}?',
  },
  shallowCopyWarningForDuplicate: {
    id: `${scope}.shallowCopyWarningForDuplicate`,
    defaultMessage: 'You are duplicating content into the same project. Art assets found in this content <b>WILL</b> carry their original Alfresco link.',
  },
  deepCopyWarningForDuplicate: {
    id: `${scope}.deepCopyWarningForDuplicate`,
    defaultMessage: 'You are duplicating content to a new project. Art assets found in this content will <b>NOT</b> carry their original Alfresco link.',
  },
  refreshNote: {
    id: `${scope}.refreshNote`,
    defaultMessage: 'Copying may take a while. Do not refresh your browser.',
  },
  duplicate: {
    id: `${scope}.duplicate`,
    defaultMessage: 'Duplicate',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
});
